import React from 'react';
import { User } from '../../types';

interface ParticipantsPanelProps {
  participants: User[];
  moderatorId?: string;
  /** Ids of participants who have already voted. */
  votedUserIds: Set<string>;
  /** Vote marks are only meaningful while a session is open and unrevealed. */
  showVoteStatus: boolean;
  currentUserId: string;
  isModerator: boolean;
  onLeave: () => void;
  onMakeModerator: (userId: string) => void;
}

const ParticipantsPanel: React.FC<ParticipantsPanelProps> = ({
  participants,
  moderatorId,
  votedUserIds,
  showVoteStatus,
  currentUserId,
  isModerator,
  onLeave,
  onMakeModerator,
}) => (
  <div className="participants-panel">
    <h3>参加者 ({participants.length}人)</h3>
    <ul className="participants-list">
      {participants.map((participant) => {
        const hasVoted = votedUserIds.has(participant.id);
        const isSelf = participant.id === currentUserId;
        const isCurrentModerator = participant.id === moderatorId;

        return (
          <li key={participant.id} className="participant-item">
            {participant.display_name}
            {isCurrentModerator && <span className="moderator-badge">モデレーター</span>}

            <div className="participant-right">
              {showVoteStatus && (
                <span className={`vote-status ${hasVoted ? 'voted' : 'not-voted'}`}>
                  {hasVoted ? '✓' : '○'}
                </span>
              )}
              <div className="participant-actions">
                {isModerator && !isCurrentModerator && (
                  <button
                    onClick={() => onMakeModerator(participant.id)}
                    className="participant-action-btn"
                  >
                    モデレーターにする
                  </button>
                )}
                {isSelf && (
                  <button onClick={onLeave} className="participant-action-btn">
                    退出
                  </button>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

export default ParticipantsPanel;
